// Algolia is temporarily disabled. Keep the implementation commented for the later rollout.
// import algoliasearch from 'algoliasearch';

const ALGOLIA_APP_ID = 'ZQ94LW7EIL';
const ALGOLIA_SEARCH_KEY = 'fee1c82decbf89b9c8ce50a062c139a5';

/**
 * Resolves the appropriate Algolia index name based on the active environment.
 * - Production: videos_production
 * - Staging:    videos_staging
 * - Dev:        videos_dev (fallback)
 */
export const getAlgoliaIndexName = () => {
	const apiUrl = import.meta.env.VITE_APP_API_URL || '';
	const title = import.meta.env.VITE_APP_TITLE || '';

	if (apiUrl.includes('app.thegodfreymethod.com')) return 'videos_production';
	if (apiUrl.includes('orca-app-ixna2.ondigitalocean.app') || title.includes('Staging')) return 'videos_staging';
	return 'videos_dev';
};

// const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);

// export const getVideosIndex = () => algoliaClient.initIndex(getAlgoliaIndexName());
export const getVideosIndex = () => null;

/**
 * Sends a click Insights event to Algolia.
 * Called from the frontend when a user clicks a video card.
 * This feeds the Recommend model with click behaviour data.
 *
 * @param {string} objectID   - Algolia objectID (= MongoDB _id of the video)
 * @param {string} userToken  - userId if logged in, otherwise a stable anonymous id
 * @param {string} [queryID]  - Algolia queryID from the search response (if click came from search)
 * @param {number} [position] - 1-based position of the hit in the result list
 */
export const sendClickEvent = async ({ objectID, userToken, queryID, position }) => {
	if (!objectID) return;
	try {
		console.log(`[Algolia Insights] Sending click → objectID: ${objectID}, userToken: ${userToken || 'anonymous'}, index: ${getAlgoliaIndexName()}`);
		const res = await fetch(`${import.meta.env.VITE_APP_API_URL}/algolia/events`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				eventType: 'click',
				eventName: 'Video Clicked',
				objectIDs: [String(objectID)],
				userToken: String(userToken || 'anonymous'),
				...(queryID && { queryID }),
				...(position && { positions: [position] }),
			}),
		});
		if (res.ok) {
			console.log('[Algolia Insights] Click event sent successfully');
		} else {
			console.error('[Algolia Insights] Click event rejected', res.status);
		}
	} catch (err) {
		console.error('[Algolia Insights] Failed to send click event:', err.message);
	}
};

/**
 * Sends a conversion Insights event to Algolia.
 * Called from the frontend when a user performs a conversion action (e.g., saving/bookmarking a video).
 *
 * @param {string} objectID   - Algolia objectID (= MongoDB _id of the video)
 * @param {string} userToken  - userId if logged in, otherwise a stable anonymous id
 * @param {string} [eventName] - Label for the conversion event (default: 'Video Saved')
 * @param {string} [queryID]  - Algolia queryID if conversion came from search
 */
export const sendConversionEvent = async ({ objectID, userToken, eventName = 'Video Saved', queryID }) => {
	if (!objectID) return;
	try {
		console.log(`[Algolia Insights] Sending conversion '${eventName}' → objectID: ${objectID}, userToken: ${userToken || 'anonymous'}, index: ${getAlgoliaIndexName()}`);
		const res = await fetch(`${import.meta.env.VITE_APP_API_URL}/algolia/events`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				eventType: 'conversion',
				eventName,
				objectIDs: [String(objectID)],
				userToken: String(userToken || 'anonymous'),
				...(queryID && { queryID }),
			}),
		});
		if (res.ok) {
			console.log('[Algolia Insights] Conversion event sent successfully');
		} else {
			console.error('[Algolia Insights] Conversion event rejected', res.status);
		}
	} catch (err) {
		console.error('[Algolia Insights] Failed to send conversion event:', err.message);
	}
};

